import BaseStore from '@/store/base-store'

const options = {}
export default new BaseStore('customer-activities', options)



// WEBPACK FOOTER //
// ./src/store/modules/customer-activities.store.js